import { render, staticRenderFns } from "./BulkThresholdDrawer.vue?vue&type=template&id=66cfae88"
import script from "./BulkThresholdDrawer.vue?vue&type=script&lang=js"
export * from "./BulkThresholdDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports